import { Component, FunctionComponent } from "preact";

import * as dateish from "@/dateish";
import { AppState } from "@/appstate";

import FileImport from "./file_import";
import BirdPage from "./pages/bird_page";
import HomePage from "./pages/home_page";
import DayPage from "./pages/day_page";
import MonthPage from "./pages/month_page";
import { Store } from "@/db";
import { Observation } from "@/ebird/ebird";

export const Router: FunctionComponent<AppState> = (props) => {
  const { url: { searchParams, pathname } } = props;
  const id = searchParams.get('id');

  switch (pathname) {
    case "":
    case "/":
      return <HomePage {...props} />;
    case "/bird":
    case "/bird/":
      return <BirdPage app={ props } spcode={ id! } />;
    case "/date":
    case "/date/": {
      const doy = searchParams.get('doy');
      if (doy != null) { // TODO and is valid DoY
        return <DayPage store={ props.store } date={ doy as dateish.DoY } />;
      }
      const moy = searchParams.get('moy');
      if (moy != null) {
        return <MonthPage store={ props.store } moy={ moy as dateish.MoY } />;
      }
    } break;
    case "/import":
    case "/import/":
      return <FileImport store={ props.store } />;
  }

  return <div>404</div>;
};

export class Header extends Component<{ store: Store, allObservations: Observation[] }> {
  render() {
    const { allObservations } = this.props;

    return <header>
      <a href='/'>Birding Days</a>
      { allObservations.length > 0 &&
        <a href='#' onClick={ this.onReset }>Reset</a>
      }
    </header>
  }

  onReset = async () => {
    localStorage.clear(); // TODO: remove eventually
    await this.props.store.clearObservations();
    document.location.href = "/";
  }
}

const Footer: FunctionComponent = () => {
  return <footer/>; // TODO: Anything?
}

const App: FunctionComponent<AppState> = (props) => {
  const { allObservations, store } = props;

  // TODO: Clear the hash on the home page
  // TODO: Fix the file import here?
  return <>
    <Header store={ store } allObservations={ allObservations } />
    { allObservations.length > 0 ?
        <Router {...props} /> :
        <FileImport store={ store } />
    }
    <Footer/>
  </>;
}

export default App;
